const phoneFieldNormalize = (value) => {
  const rules = [
    {
      re: /(\D)/g,
      replacer: '',
    },
    {
      re: /^(.*)$/g,
      replacer: function (digits) {
        return digits ? '+' + digits : ''
      },
    },
    {
      re: /\s+$/g,
      replacer: '',
    },
  ]

  return rules
    .reduce((value, rule) => value.replace(new RegExp(rule.re), rule.replacer), value)
    .trim()
}

export default phoneFieldNormalize
